/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Finals_Already_StartedInputs */



/**
* | output |
* | --- |
* | "Finals already started" |
*
* @param {Err_Tournament_Finals_Already_StartedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_finals_already_started = /** @type {((inputs?: Err_Tournament_Finals_Already_StartedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Finals_Already_StartedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La finale a déjà commencé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las finales ya han comenzado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As finais já começaram")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le finali sono già iniziate")
	return /** @type {LocalizedString} */ ("Finals already started")
});